"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var properties_1 = require("../model/properties");
var properties_2 = require("./readers/properties");
var layout_1 = require("./readers/layout");
var module_registry_service_1 = require("../module-registry.service");
var core_1 = require("@angular/core");
var interpreter_utils_1 = require("../interpreter-utils");
var immutable_1 = require("immutable");
var reading_context_1 = require("./reading-context");
exports.formModuleRegistryKey = new core_1.InjectionToken('module registry service for forms');
exports.pageModuleRegistryKey = new core_1.InjectionToken('module registry service for pages');
exports.fieldsProviderKey = new core_1.InjectionToken('fields provider function that returns fields for given category');
var LayoutReadingService = /** @class */ (function () {
    function LayoutReadingService(formModuleRegistry, pageModuleRegistry, fieldsProvider) {
        this.formModuleRegistry = formModuleRegistry;
        this.pageModuleRegistry = pageModuleRegistry;
        this.fieldsProvider = fieldsProvider;
    }
    LayoutReadingService_1 = LayoutReadingService;
    LayoutReadingService.read = function (formJson, category, readerProvider, controlsProvider) {
        var formObject = JSON.parse(formJson);
        var properties = new properties_1.LayoutPropertiesModel();
        var propertiesReader = new properties_2.LayoutPropertiesReader(category, properties);
        JSON.parse(formObject.property, function (key, value) {
            return propertiesReader.read(key, value);
        });
        var fixedKeys = LayoutReadingService_1.getFixedKeys(formObject.layout);
        return controlsProvider(fixedKeys).pipe(operators_1.map(function (mappedControl) {
            var layoutReader = readerProvider(properties, function (key) {
                if (mappedControl.has(key)) {
                    return mappedControl.get(key);
                }
                else {
                    throw new Error("control with " + key + " selector was not found in any of available modules");
                }
            });
            return interpreter_utils_1.getRequiredProperty(JSON.parse(formObject.layout, function (key, value) {
                return layoutReader.read(key, value);
            }), category);
        }));
    };
    LayoutReadingService.getFixedKeys = function (layoutStr) {
        if (layoutStr.includes('moduleKeys')) {
            var keysSubStr = layoutStr.substring(layoutStr.lastIndexOf('moduleKeys'));
            return JSON.parse(keysSubStr.substr(keysSubStr.indexOf('['), keysSubStr.indexOf(']') - keysSubStr.indexOf('[') + 1));
        }
        return undefined;
    };
    LayoutReadingService.prototype.readForm = function (formJson, category) {
        var _this = this;
        return this.fieldsProvider(category).pipe(operators_1.map(function (fields) {
            return immutable_1.Map(fields.map(function (field) { return [
                field.getMetaFieldId().getSystemName(),
                field,
            ]; }));
        }), operators_1.switchMap(function (fieldMap) {
            return LayoutReadingService_1.read(formJson, category, function (b, c) {
                return new layout_1.FormLayoutModelReader(category, b, c, new reading_context_1.ReadingContext(function (field) { return fieldMap.get(field); }));
            }, function (fixedModuleKeys) {
                return _this.formModuleRegistry.allControlsMapped(fixedModuleKeys);
            });
        }), operators_1.first());
    };
    LayoutReadingService.prototype.readPage = function (formJson, name) {
        var _this = this;
        return LayoutReadingService_1.read(formJson, name, function (b, c) {
            return new layout_1.PageLayoutModelReader(name, b, c, new reading_context_1.ReadingContext(function (_) {
                return undefined;
            }));
        }, function () { return _this.pageModuleRegistry.allControlsMapped(); });
    };
    LayoutReadingService = LayoutReadingService_1 = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Optional()),
        __param(0, core_1.Inject(exports.formModuleRegistryKey)),
        __param(1, core_1.Optional()),
        __param(1, core_1.Inject(exports.pageModuleRegistryKey)),
        __param(2, core_1.Inject(exports.fieldsProviderKey)),
        __metadata("design:paramtypes", [module_registry_service_1.ModuleRegistryService,
            module_registry_service_1.ModuleRegistryService, Object])
    ], LayoutReadingService);
    return LayoutReadingService;
    var LayoutReadingService_1;
}());
exports.LayoutReadingService = LayoutReadingService;
//# sourceMappingURL=layout-reading.service.js.map